import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.css']
})
export class ContactListComponent implements AfterViewInit {
  displayedColumns: string[] = ['sno', 'name', 'jobTitle', 'accountName', 'officePhone', 'email', 'user', 'dateCreated'];
  dataSource = new MatTableDataSource<Contact>(CONTACT_DATA);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  onChangeActive(event: any) {
    // const value = event.value;
    const value = (event.target as HTMLSelectElement).value;

    this.dataSource.data = CONTACT_DATA.filter(contact => {
      if (!value) return true;
      return contact.status?.toLowerCase() === value;
    });
  }
}

// Dummy Data (Replace with real API data)
export interface Contact {
  name: string;
  jobTitle: string;
  accountName: string;
  officePhone: string;
  email: string;
  user: string;
  dateCreated: string;
  status?: string; // for filtering (active/inactive)
}

const CONTACT_DATA: Contact[] = [
  {
    name: 'Alice Johnson',
    jobTitle: 'Manager',
    accountName: 'Acme Corp',
    officePhone: '123-456-7890',
    email: 'alice@acme.com',
    user: 'ajohnson',
    dateCreated: '2023-01-01',
    status: 'active'
  },
  {
    name: 'Bob Smith',
    jobTitle: 'Developer',
    accountName: 'Globex',
    officePhone: '987-654-3210',
    email: 'bob@globex.com',
    user: 'bsmith',
    dateCreated: '2023-02-01',
    status: 'inactive'
  },
  // Add more...
];
